import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core'
import { UntypedFormControl } from '@angular/forms'
import moment from 'moment-timezone'
import * as R from 'ramda'

function getTimezones() {
  return R.filter((z: any) => z && z.indexOf('/') > -1 && z.indexOf('Etc/') < 0, moment.tz.names())
}

@Component({
  selector: 'app-timezone-select',
  templateUrl: './timezone-select.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TimezoneSelectComponent implements OnInit {
  timezoneList = getTimezones()

  @Input() ctrl = new UntypedFormControl()
  @Input() inline = false
  @Input() label = $localize`Time Zone`
  constructor() {}

  ngOnInit(): void {}
}
